
// Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = 'G-X7ZV9F9FS9';

// Event categories
export const EventCategories = {
  PROMPT: 'Prompt',
  USER: 'User',
  SEARCH: 'Search',
  NAVIGATION: 'Navigation',
  ENGAGEMENT: 'Engagement',
  CONVERSION: 'Conversion'
} as const;
